import { RangeDatepicker } from "chakra-dayzed-datepicker";
import { Box } from "@chakra-ui/react"


interface IDateRangePicker {
    handleSelect: (dates: Date[]) => void
    selectedDates: Date[]
    propsConfigs?: any
}


const DateRangePicker: React.FC<IDateRangePicker> = ({ handleSelect, selectedDates, propsConfigs }) => {


    return (
        <Box >

            <RangeDatepicker
                propsConfigs={propsConfigs}
                selectedDates={selectedDates}
                onDateChange={handleSelect}

            />
        </Box>
    )
}

export default DateRangePicker